
/* Parametry z adresy je nutne cist pres URLSearchParams, ktery je dekoduje.
   Puvodni kod je rozsekaval na & a = a vkladal do FormData jeste zakodovane,
   takze se pri odeslani zakodovaly podruhe: %5B -> %255B a mezera zapsana
   jako + skoncila jako %2B. Po druhem filtru se tak z "Howard Robinson"
   stalo "Howard+Robinson", coz neodpovida zadnemu produktu -> nula vysledku
   a zmizely stitky aktivnich filtru. */
function ctiParametryZUrl() {
  var formdata = new FormData();
  new URLSearchParams(window.location.search).forEach(function (hodnota, klic) {
    formdata.append(klic, hodnota);
  });
  return formdata;
}

/* Podpis skupiny filtru = jeji aplikovany stav (zaskrtnute hodnoty,
   u ceny obe pole). Snimky podpisu se ukladaji pri nacteni a po kazde
   aplikaci ci prekresleni; kdyz se DOM od snimku lisi, ma skupina
   rozpracovane, jeste neaplikovane zmeny a AJAX prekresleni ji nesmi
   prepsat (odpoved leticiho pozadavku by vybrane hodnoty smazala). */
function podpisSkupiny(skupina) {
  if (skupina.classList.contains('filter-slider')) {
    var min = skupina.querySelector('.slider-change-value-min');
    var max = skupina.querySelector('.slider-change-value-max');
    return kanonickaCena(min) + '\u0001' + kanonickaCena(max);
  }
  return Array.from(skupina.querySelectorAll("input[type='checkbox']:checked"))
    .map(function (input) { return input.getAttribute('value'); }).join('\u0001');
}

/* Cenova pole normalizuji ruzne ruce ("40" vs "40.00" - focusout obsluha
   ve filtry-mobil-oprava.js pise parseInt), proto se cena porovnava
   kanonicky jako cislo, ne jako text - jinak by kosmeticky rozdil
   oznacil skupinu za rozpracovanou a ta by se prestala synchronizovat. */
function kanonickaCena(input) {
  if (!input || input.value === '') return '';
  var cislo = parseFloat(input.value);
  return isNaN(cislo) ? input.value : String(cislo);
}

function ulozSnimekSkupiny(skupina) {
  if (skupina && skupina.dataset && skupina.dataset.index !== undefined) {
    FacetFiltersForm.snimkySkupin[skupina.dataset.index] = podpisSkupiny(skupina);
  }
}

/* verze 2026073002 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.querySelectorAll('.js-filter').forEach(function (skupina) { ulozSnimekSkupiny(skupina); });
    this.querySelectorAll(".set-filter").forEach(el=>{
        el.addEventListener("click", (el)=>{
            console.log("set-filter");
            this.applyFilter(el.target.dataset.filter,el.target.dataset.filter_type,el.target.dataset.filter_id);
            
        })
    })

    document.addEventListener('click',(ev)=>{
      if(ev.target && ev.target.classList.contains('sort-item')){
          //console.log("click");
          const val = ev.target.getAttribute("data-value");
          document.querySelector("input[name='sort_by']").setAttribute("value", val);
          zuty.hideVisibleElement("sorting");
          this.onSubmitHandler(ev, false);
      }
    });

    this.querySelectorAll(".reset-filter").forEach(el=>{
        el.addEventListener("click", (el)=>{
            console.log("reset-filter");
            this.resetFilter(el.target.dataset.filter,el.target.dataset.filter_type,el.target.dataset.filter_id);
        })
    })


    this.debouncedOnSubmit = debounce((event) => {
      
      this.onSubmitHandler(event);
    }, 500);

    
    //this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  // custom func to reset filter on request
  resetFilter(el, type, parent) {
      // aktualni uri
      let formdata = ctiParametryZUrl();
      /* page se pri kazde zmene filtru zahazuje: zuzeny vysledek nemusi
         mit tolik stranek a Shopify by vratil prazdnou stranku. Pri
         navigaci historii (popstate) se page naopak zachovava - tam se
         parametry berou z ulozeneho stavu, ne odtud. */
      formdata.delete("page");
      if (type == "list") {
        formdata.delete(el);
        document.querySelectorAll("input[name='"+ el + "']").forEach((input)=>{
          input.checked = false;
        });
      } else if (type == "price_range") {
        formdata.delete(el+".gte");
        formdata.delete(el+".lte");
        const min = document.querySelector("input[name='"+ el + ".gte']");
        const max = document.querySelector("input[name='"+ el + ".lte']");
        min.value = min.getAttribute("min");
        max.value = max.getAttribute("max");
        $("#slider-range").slider("values", 0, min.value);
        $("#slider-range").slider("values", 1, max.value);
      }
      /* DOM a snimek se meni PRED renderPage - odpoved z cache se kresli
         synchronne a proti staremu snimku by skupinu preskocila. */
      var skupina = document.getElementById(parent);
      skupina.classList.remove("active");
      ulozSnimekSkupiny(skupina);
      FacetFiltersForm.renderPage(new URLSearchParams(formdata).toString());
  }


  // custom func to apply filter on request
  applyFilter(el, type, parent) {
    let formdata = ctiParametryZUrl();
    // page zahazujeme ze stejneho duvodu jako v resetFilter
    formdata.delete("page");
    if (type == "list") {
        formdata.delete(el);
        document.querySelectorAll("input[name='"+ el + "']:checked").forEach((checkbox)=>{
            formdata.append(el, checkbox.getAttribute("value"));
        });
    } else if (type == "price_range") {
        formdata.delete(el + ".lte");
        formdata.delete(el + ".gte");
        formdata.append(el+".gte", document.querySelector(".slider-change-value-min").value);
        formdata.append(el+".lte", document.querySelector(".slider-change-value-max").value);
    }
    /* snimek pred renderPage - viz resetFilter */
    var skupina = document.getElementById(parent);
    skupina.classList.remove("active");
    ulozSnimekSkupiny(skupina);
    FacetFiltersForm.renderPage(new URLSearchParams(formdata).toString());
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    /* Guard proti zavodu odpovedi: kdyz uzivatel vyvola dalsi pozadavek
       drive, nez dorazi predchozi, smi vykreslit jen odpoved toho
       posledniho - pomalejsi stara odpoved by jinak prepsala novejsi
       stav (URL by ukazovala B, stranka A). Cache cesta je synchronni,
       ta je vzdy aktualni. */
    FacetFiltersForm.posledniPozadavek = `${window.location.pathname}?section_id=${sections[0].section}&${searchParams}`;
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        // zastarala odpoved (mezitim odesel novejsi pozadavek) se jen ulozi do cache
        if (url !== FacetFiltersForm.posledniPozadavek) return;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    /* Nove karty prichazeji ze serveru vzdy s prazdnym srdickem
       (add-to-favourite-empty) - stav ulozenych oblibenych zna jen
       localStorage v prohlizeci. Bez teto synchronizace se uz ulozeny
       produkt po filtrovani ci razeni tvaril jako neulozeny. */
    if (typeof window.replaceFavourites === 'function') window.replaceFavourites();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    /* Skupiny filtru se sladi s odpovedi serveru, jinak po AJAX
       filtrovani zustanou stare pocty, disabled a zaskrtnuti (a pri
       navigaci historii stav neodpovida obnovenym vysledkum). Skupiny
       se paruji pres data-index, ktery nese param_name filtru - poradi
       by se rozjelo, kdyby nektera skupina v odpovedi chybela.

       - Skupina, kterou server uz neposila, se skryje; kdyz se vrati,
         zase se ukaze. Uplne nova skupina (na strance od nacteni nebyla)
         se nevklada - vznika jen zmenou konfigurace S&D mezi nactenim
         a pozadavkem a potrebovala by reinicializaci obsluhy.
       - Skupina s rozpracovanymi, jeste neaplikovanymi zmenami (DOM se
         lisi od ulozeneho snimku) se neprepisuje - odpoved leticiho
         pozadavku by uzivateli smazala vybrane hodnoty.
       - U seznamu se prekresluje jen <header>: tlacitka ve footeru tak
         zustavaji v DOM i s primo navazanymi listenery (.set-filter,
         .reset-filter).
       - U cenoveho filtru (.filter-slider) se innerHTML nesaha - jQuery
         UI posuvnik se inicializuje jen pri nacteni stranky - ale
         hodnoty poli a posuvniku se synchronizuji, jinak by po navratu
         historii ci resetu nasledne razeni (sklada pozadavek z poli
         formulare) cenovy filtr potichu zahodilo nebo zmenilo. */
    const zdrojoveSkupiny = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const indexyVOdpovedi = new Set(Array.from(zdrojoveSkupiny).map((el) => el.dataset.index));
    document.querySelectorAll('#FacetFiltersForm .js-filter').forEach((target) => {
      const zustava = indexyVOdpovedi.has(target.dataset.index);
      if (!zustava && target.style.display !== 'none') {
        /* Skryta skupina nesmi nechat zaskrtnute hodnoty ve formulari -
           razeni ho odesila cely a neviditelne by je aplikovalo. */
        target.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
          checkbox.checked = false;
        });
        ulozSnimekSkupiny(target);
      }
      target.style.display = zustava ? '' : 'none';
    });

    zdrojoveSkupiny.forEach((source) => {
      const target = document.querySelector(`#FacetFiltersForm .js-filter[data-index="${source.dataset.index}"]`);
      if (!target) return;
      const snimek = FacetFiltersForm.snimkySkupin[source.dataset.index];
      if (snimek !== undefined && podpisSkupiny(target) !== snimek) return;

      if (target.classList.contains('filter-slider')) {
        FacetFiltersForm.synchronizujCenu(source, target);
      } else {
        const sourceHeader = source.querySelector('.filter-items > header');
        const targetHeader = target.querySelector('.filter-items > header');
        if (sourceHeader && targetHeader) targetHeader.innerHTML = sourceHeader.innerHTML;
      }
      ulozSnimekSkupiny(target);
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static synchronizujCenu(source, target) {
    const cilMin = target.querySelector('.slider-change-value-min');
    const cilMax = target.querySelector('.slider-change-value-max');
    if (!cilMin || !cilMax) return;
    const zdrojMin = source.querySelector('.slider-change-value-min');
    const zdrojMax = source.querySelector('.slider-change-value-max');
    /* Liquid vypisuje atribut value jen u nastaveneho filtru - chybejici
       atribut znamena nenastaveno, tedy okraje rozsahu. */
    const min = zdrojMin && zdrojMin.getAttribute('value') !== null
      ? zdrojMin.getAttribute('value') : cilMin.getAttribute('min');
    const max = zdrojMax && zdrojMax.getAttribute('value') !== null
      ? zdrojMax.getAttribute('value') : cilMax.getAttribute('max');
    cilMin.value = min;
    cilMax.value = max;
    if (window.jQuery && $('#slider-range').length) {
      $('#slider-range').slider('values', 0, min);
      $('#slider-range').slider('values', 1, max);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    let facetsEmpty = true;
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      if (activeFacetsElement.innerHTML.trim() != "") {
        facetsEmpty = false;
      }
    })
    if (facetsEmpty) {
        document.querySelector(".active-filters-wrapper").style.display = "none";
    } else {
        document.querySelector(".active-filters-wrapper").style.display = "block";
    }
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }
  // custom func to hide selected checkbox/price_range
  hideFilterSelectedFilterOption(type, name, value) {
    if (type == "list") {
        /* Hodnota se nesmi vkladat do selektoru - apostrof v ni (napr.
           autor "O'Brien") by selektor rozbil a vyjimka by zastavila
           i nasledny renderPage. Porovnava se retezcove. */
        const checkbox = Array.from(document.querySelectorAll("input[type='checkbox']"))
          .find(function (input) { return input.name === name && input.getAttribute('value') === value; });
        if (!checkbox) return;
        checkbox.checked = false;
        /* Ze snimku se odebira JEN tato hodnota. Snimek celeho DOM by
           oznacil za aplikovane i pripadne rozpracovane zaskrtnuti
           jinych hodnot, ktere pozadavek stitku neodesila - odpoved by
           je pak smela smazat. */
        const skupina = checkbox.closest('.js-filter');
        if (skupina && skupina.dataset.index !== undefined) {
          const snimek = FacetFiltersForm.snimkySkupin[skupina.dataset.index];
          if (snimek !== undefined) {
            FacetFiltersForm.snimkySkupin[skupina.dataset.index] = snimek
              .split('\u0001')
              .filter(function (hodnota) { return hodnota !== value && hodnota !== ''; })
              .join('\u0001');
          }
        }
    } else if (type == "price_range") {
        const min = document.querySelector("input[name='"+ name + ".gte']");
        const max = document.querySelector("input[name='"+ name + ".lte']");
        min.value = min.getAttribute("min");
        max.value = max.getAttribute("max");
        $("#slider-range").slider("values", 0, min.value);
        $("#slider-range").slider("values", 1, max.value);
        ulozSnimekSkupiny(min.closest('.js-filter'));
    }
  }

  onSubmitHandler(event, preventDef = true) {
    if (preventDef != null)
      event.preventDefault();
    let formData = new FormData(event.target.closest('form'));
    // overime, ze se cena nezmenila oproti minimu a maximu
    if (document.querySelector("input[name='filter.v.price.gte']") != null && document.querySelector("input[name='filter.v.price.lte']")) {
        const min = document.querySelector("input[name='filter.v.price.gte']").getAttribute("min");
        const max = document.querySelector("input[name='filter.v.price.lte']").getAttribute("max");
        if (formData.get("filter.v.price.gte") == min && formData.get("filter.v.price.lte") == max) {
            formData.delete("filter.v.price.gte");
            formData.delete("filter.v.price.lte");
        }
    }

    /* Razeni odesila cely formular, tedy i pripadne rozpracovane, jeste
       "nepouzite" hodnoty - tim se realne aplikuji. Snimky tomu musi
       odpovidat, jinak by se skupina uz nikdy nesynchronizovala
       (a navrat historii by ji neuml vratit). */
    document.querySelectorAll('#FacetFiltersForm .js-filter').forEach(function (skupina) {
      ulozSnimekSkupiny(skupina);
    });
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    // url_to_remove od Shopify muze nest i page - po zmene filtru se zahazuje
    const params = new URLSearchParams(url);
    params.delete('page');
    /* DOM a snimek pred renderPage - cache cesta kresli synchronne */
    const targetData = event.currentTarget.dataset;
    this.hideFilterSelectedFilterOption(targetData.filter_type, targetData.filter, targetData.filter_value);
    FacetFiltersForm.renderPage(params.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.snimkySkupin = {};
FacetFiltersForm.posledniPozadavek = null;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/* Tlacitko "Anwenden" ve spodni liste mobilniho panelu filtru nemelo zadnou
   obsluhu, takze uzivatel po vyberu filtru zustal trcet v panelu a vysledky
   nevidel. Filtry uz v tu chvili aplikovane jsou (dela to .set-filter),
   staci tedy panel zavrit. Delegovane, aby to prezilo prekresleni stranky. */
document.addEventListener('click', function (ev) {
  var el = ev.target && ev.target.closest ? ev.target.closest('.apply-filters') : null;
  if (!el) return;
  ev.preventDefault();
  try {
    if (window.zuty && typeof window.zuty.hideVisibleElement === 'function') {
      window.zuty.hideVisibleElement(ev, true);
    }
  } catch (e) { /* fallback nize */ }
  document.body.classList.remove('filters-visible');
  document.body.removeAttribute('data-visible-element');
  document.querySelectorAll('.filter.active').forEach(function (f) { f.classList.remove('active'); });
  var ov = document.querySelector('.overlay');
  if (ov) ov.remove();
  document.body.classList.remove('has-overlay');
});

/* Horni "Vycistit vse" v zahlavi mobilniho panelu filtru drive nic
   nemazalo: script.min.js mu dava jen preventDefault a rodicovsky
   .close-filters panel pouze zavre. Tady se skutecne odstrani vsechny
   filtry (parametry filter.* a page), hledany vyraz a razeni zustavaji.
   Delegovane, aby to prezilo prekresleni; zavreni panelu se nechava na
   probublani do .close-filters. */
document.addEventListener('click', function (ev) {
  var el = ev.target && ev.target.closest ? ev.target.closest('.reset-all-filters') : null;
  if (!el) return;
  ev.preventDefault();
  var formdata = ctiParametryZUrl();
  var klice = [];
  formdata.forEach(function (hodnota, klic) {
    if (klice.indexOf(klic) === -1) klice.push(klic);
  });
  klice.forEach(function (klic) {
    if (klic.indexOf('filter.') === 0 || klic === 'page') formdata.delete(klic);
  });
  /* Na strance vyhledavani musi pozadavek obsahovat q, jinak Shopify vrati
     stranku bez vysledku (viz komentar u skrytych poli ve
     snippets/facets.liquid). URL je nemusi obsahovat vzdy, proto se
     chybejici doplni ze skrytych poli formulare. */
  var form = document.getElementById('FacetFiltersForm');
  if (form) {
    ['q', 'options[prefix]', 'type'].forEach(function (nazev) {
      if (formdata.get(nazev)) return;
      var input = form.querySelector('input[type="hidden"][name="' + nazev + '"]');
      if (input && input.value) formdata.append(nazev, input.value);
    });
  }
  /* Sync UI PRED renderPage (cache cesta kresli synchronne): odskrtnout
     checkboxy, vratit posuvnik ceny na okraje a aktualizovat snimky -
     reset je aplikovana zmena vsech skupin. */
  if (form) {
    form.querySelectorAll("input[type='checkbox']").forEach(function (checkbox) {
      checkbox.checked = false;
    });
  }
  var min = document.querySelector("input[name='filter.v.price.gte']");
  var max = document.querySelector("input[name='filter.v.price.lte']");
  if (min && max) {
    min.value = min.getAttribute('min');
    max.value = max.getAttribute('max');
    if (window.jQuery && $('#slider-range').length) {
      $('#slider-range').slider('values', 0, min.value);
      $('#slider-range').slider('values', 1, max.value);
    }
  }
  document.querySelectorAll('#FacetFiltersForm .js-filter').forEach(function (skupina) {
    ulozSnimekSkupiny(skupina);
  });
  FacetFiltersForm.renderPage(new URLSearchParams(formdata).toString());
});
